import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { ApiContext } from '../api';
import AppContext from './AppContext';
export default (function (_ref) {
  var children = _ref.children,
      api = _ref.api;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      snackMessage = _useState6[0],
      setSnackMessage = _useState6[1];

  var displaySnackMessage = function displaySnackMessage(message, type) {
    return setSnackMessage({
      type: type,
      message: message
    });
  };

  var closeSnackbar = function closeSnackbar() {
    return setSnackMessage();
  };

  return React.createElement(ApiContext.Provider, {
    value: api
  }, React.createElement(AppContext.Provider, {
    value: {
      loading: loading,
      setLoading: setLoading,
      error: error,
      setError: setError,
      snackMessage: snackMessage,
      setSnackMessage: setSnackMessage,
      displaySnackMessage: displaySnackMessage,
      closeSnackbar: closeSnackbar
    }
  }, children));
});